import { render } from "./OnboardDialog.vue?vue&type=template&id=60333940&scoped=true"
import script from "./OnboardDialog.vue?vue&type=script&lang=js"
export * from "./OnboardDialog.vue?vue&type=script&lang=js"

import "./OnboardDialog.vue?vue&type=style&index=0&id=60333940&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60333940"]])

export default __exports__